import { ArrowRight } from "lucide-react";
import { ScrollReveal } from "./Reveal";

export const CtaSection = () => (
  <section data-testid="cta-section" className="py-28 lg:py-40 bg-[#111111] border-y border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <ScrollReveal>
        <p className="font-mono2 text-[11px] uppercase tracking-[0.35em] text-[#8A8A85] mb-8">Got a story?</p>
        <h2 className="font-display leading-[0.95] text-[11vw] sm:text-[8vw] lg:text-[6.5vw] max-w-6xl" data-testid="cta-heading">
          Let's make something people remember.
        </h2>
      </ScrollReveal>
      <ScrollReveal delay={0.15}>
        <p className="mt-8 text-base md:text-lg text-[#8A8A85] max-w-xl">
          Tell me what you're working on and let's create something cinematic.
        </p>
        <button
          data-testid="cta-start-project-btn"
          onClick={() => window.__openEnquiry()}
          className="group mt-10 flex items-center gap-3 bg-[#F2F0EB] text-[#0A0A0A] font-display text-sm tracking-[0.08em] px-10 py-5 rounded-full hover:scale-105 transition-transform duration-300"
        >
          Start a Project
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1.5 transition-transform duration-300" />
        </button>
      </ScrollReveal>
    </div>
  </section>
);
